<section class="share-link-widget" [class.mobile]="deviceService.isMobile()" *ngIf="platform.isBrowser">
  <app-icon width="50" height="50" file="emoji" icon="party"></app-icon>
  <div class="text-block">
    <div class="top">
      <h3 class="title bold">{{ pane?.title | customLocale }}</h3>
    </div>
    <div #shareLinkRef class="bottom">
      <span class="text normal">{{ pane?.subtitle | customLocale }}</span>&nbsp;&nbsp;
      <span [ngxClipboard]
            [cbContent]="contentUrl"
            (cbOnSuccess)="onCopied($event)"
            [container]="shareLinkRef"
            class="text link medium">{{ 'library.share-link-widget.link' | customLocale }}</span>&nbsp;
      <div class="copy-informer" [class.active]="this.copied">{{'invite-card.link-copied' | customLocale}}</div>
    </div>
  </div>
</section>
